import { Component } from "@angular/core";

@Component({
  selector: "app-aip",
  templateUrl: "./aip.component.html",
  styleUrls: ["./aip.component.scss"],
})
export class AipComponent {
  featureData = [
    {
      title: "Space-saving design",
      iconSrc: "assets/images/icons/all-in-pc/space-saving-design.png",
      description:
        "Combines monitor, CPU, and speakers in one unit for a clutter-free workspace.",
    },
    {
      title: "High-resolution display",
      iconSrc: "assets/images/icons/all-in-pc/high-resolution-display.png",
      description: "Provides crisp visuals for work and entertainment.",
    },
    {
      title: "Powerful processor",
      iconSrc: "assets/images/icons/all-in-pc/powerful-processor.png",
      description:
        "Ensures fast performance for multitasking and productivity.",
    },
    {
      title: "Ample storage options",
      iconSrc: "assets/images/icons/all-in-pc/ample-storage-options.png",
      description:
        "Offers storage for files, documents, and multimedia content.",
    },
    {
      title: "Multiple ports",
      iconSrc: "assets/images/icons/all-in-pc/multiple-ports.png",
      description:
        "Allows easy connection to peripherals and external devices.",
    },
    {
      title: "Wireless connectivity",
      iconSrc: "assets/images/icons/all-in-pc/wireless-connectivity.png",
      description:
        "Supports Wi-Fi and Bluetooth for wireless internet and device connections.",
    },
    {
      title: "Built-in speakers",
      iconSrc: "assets/images/icons/all-in-pc/built-in-speakers.png",
      description: "Provides immersive sound for multimedia experiences.",
    },
  ];
}
